import { ArrowRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

const LeadMagnet = ({ onOpenQuiz }) => {
  const { t } = useTranslation();
  const resultTypes = [
    t("leadMagnet.type1"),
    t("leadMagnet.type2"),
    t("leadMagnet.type3"),
    t("leadMagnet.type4"),
    t("leadMagnet.type5"),
  ];

  return (
    <section
      id="quiz"
      data-testid="lead-magnet-section"
      className="section-padding bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="md:col-span-6 relative order-2 md:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-[0_20px_60px_rgba(44,53,36,0.15)]">
              <img
                src="/assets/brand-about.png"
                alt="Ivana Silva — perimenopause coach"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Editorial number overlay */}
            <div className="absolute -top-6 -left-6 hidden md:block bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-4 shadow-[0_10px_30px_rgba(44,53,36,0.18)]">
              <span className="font-heading text-8xl text-[#2C3524] italic leading-none block">
                3
              </span>
              <span className="block text-[#2C3524] text-[11px] font-semibold tracking-[0.25em] uppercase mt-1">
                {t("leadMagnet.minutes")}<br />{t("leadMagnet.assessment")}
              </span>
            </div>
          </div>

          {/* Content Side */}
          <div className="md:col-span-6 order-1 md:order-2">
            <span className="overline mb-4 block">
              <Sparkles className="inline-block w-3 h-3 mr-2" />
              {t("leadMagnet.overline")}
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl text-[#2C3524] leading-[1.1] mb-8">
              {t("leadMagnet.titlePart1")}<br />
              <span className="text-[#C5A059] italic">{t("leadMagnet.titlePart2")}</span>
            </h2>
            <p className="text-[#4A5543] text-lg mb-6 font-light leading-relaxed">
              {t("leadMagnet.paragraph1")}
            </p>
            <p className="text-[#4A5543] text-base mb-10 font-light">
              {t("leadMagnet.paragraph2")}
            </p>

            {/* Result Types as elegant list */}
            <ul className="space-y-3 mb-10">
              {resultTypes.map((type, index) => (
                <li
                  key={index}
                  className="flex items-center gap-4 group"
                >
                  <span className="font-heading text-xl text-[#C5A059] italic w-8">
                    0{index + 1}
                  </span>
                  <span className="text-[#2C3524] text-lg font-light">
                    {type}
                  </span>
                </li>
              ))}
            </ul>

            <button
              onClick={onOpenQuiz}
              className="btn-primary text-base group"
              data-testid="quiz-cta"
            >
              {t("leadMagnet.cta")}
              <ArrowRight className="inline-block ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>

            <p className="mt-4 text-xs text-[#4A5543]/70 tracking-wider">
              {t("leadMagnet.socialProof")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnet;
